import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'ImpossibleFinance',
  description:
    'decentralised financial protocols to give everyone the same access to financial products, previously only available to institutions and select individuals',
  image: 'https://ImpossibleFinance.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('ImpossibleFinance')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('ImpossibleFinance')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('ImpossibleFinance')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('ImpossibleFinance')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('ImpossibleFinance')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('ImpossibleFinance')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('ImpossibleFinance')}`,
      }
    case '/launchpad':
      return {
        title: `${t('Launchpad')} | ${t('ImpossibleFinance')}`,
      }
    default:
      return null
  }
}
